export default __webpack_public_path__ + "static/media/1898.1b1eb3dd.png";